import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseOutlined from '@mui/icons-material/CloseOutlined';

import { useDrawerSteps } from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { DrawerButton } from '@/features/dashboard/components/Drawer/DrawerButton';
import { DrawerHeader } from '@/features/dashboard/components/Drawer/DrawerHeader';

import { useSaveApp } from './useSaveApp';

const AddAppHeader = () => {
  const { handleAttemptBack, isEditMode, handleAttemptClose } = useDrawerSteps();
  const { isPending } = useSaveApp();

  return (
    <DrawerHeader
      before={
        <DrawerButton
          disabled={isPending}
          icon={<ArrowBackIcon />}
          title='Go back'
          variant='secondary'
          onClick={handleAttemptBack}
        />
      }
      buttons={
        <DrawerButton
          disabled={isPending}
          icon={<CloseOutlined />}
          title='Discard'
          variant='secondary'
          onClick={() => {
            if (!isPending) {
              handleAttemptClose();
            }
          }}
        />
      }
      title={isEditMode ? 'Edit app' : 'Add new app'}
    />
  );
};

export default AddAppHeader;
